import BaseButton from 'components/atoms/baseButton';
import LinkChainIcon from 'components/atoms/icons/link-cain';
import { formatTime } from 'infrastructure/functions';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

interface TimeProps {
  currentTimeSeconds: number;
  durationSeconds: number;
  callId: string;
  onClick: () => void;
  linkedCallReadingsCount?: number;
  showLinkedReadingsBtn?: boolean;
}

const Time: FC<TimeProps> = ({
  currentTimeSeconds,
  durationSeconds,
  callId,
  onClick,
  linkedCallReadingsCount = 0,
  showLinkedReadingsBtn,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.info}>
        <p className={s['info-id']}>{callId}</p>
        <p className={s['info-time']}>
          {formatTime(currentTimeSeconds)} / {formatTime(durationSeconds)}
        </p>
      </div>
      {showLinkedReadingsBtn && (
        <BaseButton
          label={t('linkedCallReadings.linkedReadings', {
            count: linkedCallReadingsCount,
          })}
          icon={<LinkChainIcon />}
          type="secondary"
          onClick={onClick}
        />
      )}
    </div>
  );
};
export default Time;
